import { defaultImgCDN, imageString } from '../../helper';

// First letter of first name + first letter after first whitespace (not last token).
export const getInitialsFromName = (name) => {
  if (!name || typeof name !== 'string') return '?';

  const trimmed = name.trim();
  if (!trimmed) return '?';

  const spaceIdx = trimmed.search(/\s/);
  if (spaceIdx === -1) {
    return trimmed.slice(0, 2).toUpperCase();
  }

  const first = trimmed.charAt(0);
  const last = trimmed.slice(spaceIdx + 1).trim().charAt(0);
  return `${first}${last}`.toUpperCase() || '?';
};

// Empty / default placeholder → '' so UI can show initials.
export const resolveChatAvatarUrl = (avatar) => {
  const raw = avatar == null ? '' : String(avatar).trim();
  if (!raw) return '';

  const url = imageString(raw);
  return !url || url === defaultImgCDN ? '' : url;
};

export const preloadChatAvatars = (avatars) => {
  const urls = [...new Set((avatars || []).map(resolveChatAvatarUrl).filter(Boolean))];
  if (urls.length === 0) return Promise.resolve();

  return Promise.all(
    urls.map(
      (url) =>
        new Promise((resolve) => {
          const img = new Image();
          const done = () => resolve(undefined);
          img.onload = done;
          img.onerror = done;
          img.src = url;
          if (img.complete) done();
        })
    )
  );
};
